<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="650px"
      :persistent="true"
    >
      <v-card
        class="pa-5"
        style="border-radius: 7px;"
        elevation="10"
      >
        <v-card-title class="pb-3">
          <v-row>
            <v-col cols="auto">
              <span style="font-weight: bold; font-size: 26px; color: #000000;">Signature Confirmation</span>
            </v-col>
            <v-col class="text-end pt-0">
              <v-btn
                icon
                @click="cancel"
                color="#000000"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <span style="font-size: 18px; color: #000000;">To make use of this signature, please click on the "Yes" button.</span> <br><br>
          <span style="font-size: 18px; color: #000000;">The following permanent signature will be used.</span> <a
            :href="link"
            target="_blank"
            style="text-decoration: none; font-size: 16px;"
          >CHANGE SIGNATURE</a> <br><br>
          <div
            v-if="signatureBlob"
            id="signature-container" 
            :style="{
              backgroundColor: '#fff',
              backgroundImage: 'none',
              border: '1px solid #ccc',
              borderRadius: '4px',
              maxWidth: '515px',
              maxHeight: '150px',
              minWidth: '515px',
              minHeight: '150px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center'
            }"
          >
            <img :src="'data:image/png;base64,' + signatureBlob">
          </div>
          <br>
          <span style="font-size: 18px; color: #000000;">If you would like to sign manually, please click the "No" button.</span> <br><br>
          <v-row align="center">
            <v-col
              cols="auto"
              class="pr-0"
            >
              <v-checkbox
                v-model="isPrompt"
                label="Don't show this message again (you can reset this option in your "
                hide-details
                class="mt-0 pt-0"
              />
            </v-col>
            <v-col class="pl-1">
              <a
                :href="link"
                target="_blank"
                style="text-decoration: none;"
              >PROFILE</a>)
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pr-2">
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            text
            @click="cancel"
          >
            <span style="font-size: 18px;">No</span>
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirm"
          >
            <span style="font-size: 18px;">Yes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
    
<script>

export default {
    props: {
      environment: {
        type: String,
        default: '',
      },
      token: {
        type: String,
        default: '',
      },
    },
    data: () => ({
        title: '',
        cancelBtn: 'Close',
        dialog: false,
        resolvePromise: undefined,
        rejectPromise: undefined,
        signatureBlob: null,
        isApprove: true,
        isPrompt: false,
        link: null,
    }),
    watch: {
      isPrompt()
      {
        this.submitAutosignPrompt();
      }
    },
    methods: {

        open(signatureBlob, isApprove = true) {
            this.dialog = true;
            this.signatureBlob = signatureBlob;
            this.isApprove = isApprove;
            const serverPrefix = process.env.VUE_APP_SERVER_PREFIX
            const serverAddress = process.env.VUE_APP_SERVER_ADDRESS
            this.link = `${serverPrefix}${this.environment}.${serverAddress}/workers/my_account`;
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            });
        },

        confirm() {
            this.dialog = false;
            this.resolvePromise(true);
        },

        cancel() {
            this.dialog = false;
            this.resolvePromise(false);
        },

        async submitAutosignPrompt()
        {
          const data = { token: this.token, toggleItem: this.isPrompt === true ? 0 : 1 };
          this.$api.post(
            `sign-pdf/envelopes/toggle-autosign-prompt`,
            data
          );
        },

        redirectSettings()
        {
          
        }
    },
};
</script>
    